import Dexie from 'dexie';
import CryptoJS from 'crypto-js';



// The database configuration
export const DB_COLLECTIONS_CONFIG = {
  treatmentProtocols: {
    name: 'treatmentProtocols',
    keyField: 'id',
    description: 'Τα θεραπευτικά πρωτόκολλα',
    endpoint: '/masterdata/treatmentprotocols',
    baseUrl: 'BASE_URL2',
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: true
  },
  uninsuredExeptions: {
    name: 'uninsuredExeptions',
    keyField: 'id',
    description: 'Οι εξαιρέσεις για τους ανασφάλιστους',
    endpoint: '/masterdata/uninsuredExeptions',
    baseUrl: 'BASE_URL2',
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: true
  },
  repeatIntervals: {
    name: 'repeatIntervals',
    keyField: 'id',
    description: 'Τα διαστήματα επανάληψης των συνταγών',
    endpoint: '/masterdata/prescriptionRepeatIntervals',
    baseUrl: 'BASE_URL2',
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: true
  },
  regularPatients: {
    name: 'regularPatients',
    keyField: 'amka',
    description: 'Οι τακτικοί ασθενείς του γιατρού (περιέχει εκτενές ιατρικό ιστορικό)',
    endpoint: null,
    baseUrl: null,
    clearOnReset: false,
    encrypted: true,
    loadOnStartup: false
  },
  monthlyPrescriptions: {
    name: 'monthlyPrescriptions',
    keyField: 'id',
    description: 'Οι επισκέψεις των τελευταίων 2 μηνών',
    endpoint: null,
    baseUrl: null,
    clearOnReset: false,
    encrypted: true,
    loadOnStartup: false
  },
  prescriptionOverrideOptions: {
    name: 'prescriptionOverrideOptions',
    keyField: 'id',
    description: 'Οι πιθανές επιλογές για παράκαμψη κανόνων συνταγογράφησης',
    endpoint: '/prescriptions/prescriptionExeptions',
    baseUrl: 'BASE_URL1',
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: true
  },
  contarindications: {
    name: 'contarindications',
    keyField: 'id',
    description: 'Οι αντενδείξεις όλων των δραστικών ουσιών',
    endpoint: '/masterdata/medicinesContraindications',
    baseUrl: 'BASE_URL2',
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: true
  },
  updateIsoDate: {
    name: 'updateIsoDate',
    keyField: '++id, collectionName',
    description: 'Πότε έγινε η τελευταία ενημέρωση της βάσης δεδομένων',
    endpoint: null,
    baseUrl: null,
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: false
  },
  spcCollection: {
    name: 'spcCollection',
    keyField: 'id',
    description: 'Η συλλογή SPC των φαρμάκων',
    endpoint: '/masterdata/medicinesSPC',
    baseUrl: 'BASE_URL2',
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: true
  },
  diseasesCollection: {
    name: 'diseasesCollection',
    keyField: 'id',
    description: 'Η συλλογή ασθενειών των φαρμάκων',
    endpoint: '/masterdata/medicinesDiseases',
    baseUrl: 'BASE_URL2',
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: true
  },
  specialityExams: {
    name: 'specialityExams',
    keyField: 'id',
    description: 'Η συλλογή εξετάσεων για την ειδικότητα του γιατρού',
    endpoint: '/refferals/specialityExams',
    baseUrl: 'BASE_URL1',
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: true
  },
  specialityICD10: {
    name: 'specialityICD10',
    keyField: 'code',
    description: 'Η συλλογή διαγνώσεων για την ειδικότητα του γιατρού',
    endpoint: '/refferals/specialityICD10',
    baseUrl: 'BASE_URL1',
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: true
  },
  discountPackages: {
    name: 'discountPackages',
    keyField: 'examination.id',
    description: 'Τα πακέτα εκπτώσεων για τις εξετάσεις',
    endpoint: '/refferals/examPackagesDiscounts',
    baseUrl: 'BASE_URL1',
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: true
  },
  doctorUnitExamLimitations: {
    name: 'doctorUnitExamLimitations',
    keyField: 'examHecuId',
    description: 'Οι περιορισμοί εξετάσεων για την επιλεγμένη μονάδα',
    endpoint: '/refferals/doctorUnitRestrictions',
    baseUrl: 'BASE_URL1',
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: true
  },
  medicinesCollection: {
    name: 'medicinesCollection',
    keyField: 'barcode',
    description: 'Όλα τα φάρμακα',
    endpoint: '/masterdata/medicines',
    baseUrl: 'BASE_URL2',
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: true
  },
  examsCollection: {
    name: 'examsCollection',
    keyField: 'id',
    description: 'Όλες οι εξετάσεις',
    endpoint: '/masterdata/exams',
    baseUrl: 'BASE_URL2',
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: true
  },
  diagnosisCollection: {
    name: 'diagnosisCollection',
    keyField: 'code',
    description: 'Όλες οι διαγνώσεις',
    endpoint: '/masterdata/diagnosis',
    baseUrl: 'BASE_URL2',
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: true
  },
  refferalTypesCollection: {
    name: 'refferalTypesCollection',
    keyField: 'id',
    description: 'Οι τύποι παραπεμπτικών',
    endpoint: '/refferals/refferalTypes',
    baseUrl: 'BASE_URL1',
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: true
  },
  docExams: {
    name: 'docExams',
    keyField: 'id',
    description: 'Οι πιο συχνά χρησιμοποιούμενες εξετάσεις του χρήστη',
    endpoint: null,
    baseUrl: null,
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: false
  },
  docIdikaMeds: {
    name: 'docIdikaMeds',
    keyField: 'id',
    description: 'Τα πιο συχνά χρησιμοποιούμενα φάρμακα του χρήστη',
    endpoint: null,
    baseUrl: null,
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: false
  },
  docExamPackages: {
    name: 'docExamPackages',
    keyField: 'packageId',
    description: 'Τα πακέτα εξετάσεων που δημιουργούνται βάσει των εξετάσεων και διαγνώσεων του χρήστη',
    endpoint: null,
    baseUrl: null,
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: false
  },
  applicationParametersCollection: {
    name: 'applicationParametersCollection',
    keyField: 'id',
    description: 'Οι παράμετροι της εφαρμογής',
    endpoint: '/masterdata/applicationparameters',
    baseUrl: 'BASE_URL2',
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: true
  },
  dosesCollection: {
    name: 'dosesCollection',
    keyField: 'id',
    description: 'Οι πιθανές δοσολογίες για τα συνταγογραφούμενα φάρμακα',
    endpoint: '/prescriptions/doseunitno',
    baseUrl: 'BASE_URL1',
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: true
  },
  frequanciesCollection: {
    name: 'frequanciesCollection',
    keyField: 'id',
    description: 'Οι πιθανές συχνότητες για τα συνταγογραφούμενα φάρμακα',
    endpoint: '/prescriptions/frequencies',
    baseUrl: 'BASE_URL1',
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: true
  },
  percentagesCollection: {
    name: 'percentagesCollection',
    keyField: 'id',
    description: 'Τα πιθανά ποσοστά συμμετοχής για τα συνταγογραφούμενα φάρμακα',
    endpoint: '/prescriptions/percentages',
    baseUrl: 'BASE_URL1',
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: true
  },
  repeatsCollection: {
    name: 'repeatsCollection',
    keyField: 'id',
    description: 'Οι πιθανές επαναλήψεις για τα συνταγογραφούμενα φάρμακα',
    endpoint: '/prescriptions/repeats',
    baseUrl: 'BASE_URL1',
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: true
  },
  noInnCasesCollection: {
    name: 'noInnCasesCollection',
    keyField: 'id',
    description: 'Οι πιθανοί λόγοι εμπορικής ονομασίας για τα συνταγογραφούμενα φάρμακα',
    endpoint: '/prescriptions/noinncases',
    baseUrl: 'BASE_URL1',
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: true
  },
  highRiskGroupsCollection: {
    name: 'highRiskGroupsCollection',
    keyField: 'id',
    description: 'Οι πιθανές ομάδες υψηλού κινδύνου για τα συνταγογραφούμενα φάρμακα',
    endpoint: '/prescriptions/highriskgroups',
    baseUrl: 'BASE_URL1',
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: true
  },
  prescriptionNonPatricipationCasesCollection: {
    name: 'prescriptionNonPatricipationCasesCollection',
    keyField: 'id',
    description: 'Οι περιπτώσεις μηδενικής συμμετοχής για τις συνταγές',
    endpoint: '/masterdata/zeroParticipationCasesPrescriptions',
    baseUrl: 'BASE_URL2',
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: true
  },
  examsNonPatricipationCasesCollection: {
    name: 'examsNonPatricipationCasesCollection',
    keyField: 'id',
    description: 'Οι περιπτώσεις μηδενικής συμμετοχής για τα παραπεμπτικά',
    endpoint: '/masterdata/zeroParticipationCasesExams',
    baseUrl: 'BASE_URL2',
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: true
  },
  referenceToCollection: {
    name: 'referenceToCollection',
    keyField: 'id',
    description: 'Οι τύποι αναφοράς (Πρός:)',
    endpoint: '/masterdata/referenceTo',
    baseUrl: 'BASE_URL2',
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: true
  },
  specialitiesCollection: {
    name: 'specialitiesCollection',
    keyField: 'id',
    description: 'Οι ειδικότητες',
    endpoint: '/masterdata/specialities',
    baseUrl: 'BASE_URL2',
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: true
  },
  icpc2Collection: {
    name: 'icpc2Collection',
    keyField: 'id',
    description: 'Η συλλογή ICPC2',
    endpoint: '/masterdata/icpc2',
    baseUrl: 'BASE_URL2',
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: true
  },
  unitTypeCollection: {
    name: 'unitTypeCollection',
    keyField: 'id',
    description: 'Η συσχέτιση μεταξύ τύπου μονάδας και αποδεκτών τύπων αναφοράς',
    endpoint: '/masterdata/unitTypes',
    baseUrl: 'BASE_URL2',
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: true
  },
  medicinesDiagnoses: {
    name: 'medicinesDiagnoses',
    keyField: 'id',
    description: 'Το ιστορικό των πιο συχνά χρησιμοποιούμενων διαγνώσεων ανά φάρμακο',
    endpoint: null,
    baseUrl: null,
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: false
  },
  examsDiagnoses: {
    name: 'examsDiagnoses',
    keyField: 'id',
    description: 'Το ιστορικό των πιο συχνά χρησιμοποιούμενων διαγνώσεων ανά εξέταση',
    endpoint: null,
    baseUrl: null,
    clearOnReset: true,
    encrypted: false,
    loadOnStartup: false
  }
};


// Create schema from configuration
const createDexieSchema = () => {
  const schema = {};
  Object.entries(DB_COLLECTIONS_CONFIG).forEach(([name, config]) => {
    schema[name] = config.keyField;
  });
  return schema;
}
//Get the collection that need to be loaded on statrt up
export const getCollectionsToLoadOnStartup = () => 
Object.entries(DB_COLLECTIONS_CONFIG)
.filter(([_, config]) => config.loadOnStartup && config.endpoint)
.map(([name, config]) => ({
  name,
  endpoint: `${config.baseUrl === 'BASE_URL1' ? 
    process.env.REACT_APP_API_URL1 : 
    process.env.REACT_APP_API_URL2}${config.endpoint}`
  })
);
//Get the collections that must be encrypted
export const getEncryptedCollections = () => 
  Object.entries(DB_COLLECTIONS_CONFIG)
.filter(([_, config]) => config.encrypted)
.map(([name]) => name
);
//Get the collections that need to be cleared in case of database reset
export const getCollectionsToClear = () => 
Object.entries(DB_COLLECTIONS_CONFIG)
.filter(([_, config]) => config.clearOnReset)
.map(([name]) => name
);
//Get collection keyFields
export const getCollectionKeyField = (collectionName) => 
DB_COLLECTIONS_CONFIG[collectionName]?.keyField;


// Initialize the database
var db = new Dexie("ERx")
// Set up database with schema from configuration
db.version(parseInt(process.env.REACT_APP_DEXIE_VERSION)).stores(createDexieSchema());


// Function to encrypt data
export const encryptData = (data, encryptionKey) => {


  if (!data) {
    throw new Error('No data provided for encryption');
  }
  return CryptoJS.AES.encrypt(JSON.stringify(data), encryptionKey).toString();
}
// Function to decrypt data
export const decryptData = (cipherText, encryptionKey) => {

  if (!cipherText) {
    throw new Error('No cipher text provided for decryption');
  }
  const bytes = CryptoJS.AES.decrypt(cipherText, encryptionKey);
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
}
// Encryption key update
export const updateEncryptionKey = async (encryptionKey) => {
  try {
    // Key generation utility using crypto API
    const generateRandomKey = (length = 32) => {
      const array = new Uint8Array(length);
      crypto.getRandomValues(array);
      return Array.from(array, byte => 
        ('0' + (byte & 0xFF).toString(16)).slice(-2)
      ).join('');
    };
    const newKey = generateRandomKey();
    
    // Get encrypted collections from configuration
    const encryptedCollections = Object.entries(DB_COLLECTIONS_CONFIG)
      .filter(([_, config]) => config.encrypted)
      .map(([name]) => name);

    // Re-encrypt all data with the new key
    await Promise.all(encryptedCollections.map(async collectionName => {
      const records = await db[collectionName].toArray();
      if (!records.length) return;

      const recryptedRecords = records.map(record => {
        const decryptedData = decryptData(record.data, encryptionKey);
        return {
          [DB_COLLECTIONS_CONFIG[collectionName].keyField]: decryptedData[DB_COLLECTIONS_CONFIG[collectionName].keyField],
          data: encryptData(decryptedData, newKey)
        };
      });

      await db[collectionName].bulkPut(recryptedRecords);
    }));

    return newKey;
  } catch (error) {
    console.error('Error updating encryption key:', error);
    throw error;
  }
};

export default db;
